/* ABCD: the customer must pick a size on purpose (v2, 23 Oct 2026).
   The theme preselects the first size (EU 36) on the product page, in the quick add drawer and on the
   cart drawer suggestions. Since 20 Oct about half of the pairs sold were EU 36.
   1. Product page and quick add: adding is blocked until a size button was clicked. The product page
      has an inline document-level capture listener that stops size clicks, so all listeners here sit on
      WINDOW (they run first). A link with ?variant= counts as a choice unless it is the first variant.
      The dynamic checkout buttons (Buy it now, Shop Pay) stay hidden until a size is chosen.
   2. Cart drawer suggestions: the button adds the SAME EU size as the shoe already in the cart, or
      sends the customer to the product page to pick a size.
   It never changes prices, variants or the cart contents by itself. */
(function () {
  'use strict';
  if (window.__abcdSizeRequired) return;
  window.__abcdSizeRequired = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lang = String(document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'nl').slice(0, 2).toLowerCase();
  var TXT = {
    nl: 'Kies eerst je maat',
    fr: 'Choisissez d’abord votre taille',
    de: 'Bitte wähle zuerst deine Größe',
    it: 'Scegli prima la tua taglia',
    en: 'Please choose your size first'
  };
  var MSG = TXT[lang] || TXT.nl;
  var REDUCED = false;
  try { REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}

  var pdpChosen = false;
  var qaChosen = false;

  var st = document.createElement('style');
  st.textContent =
    '.AbcdSizeMsg{margin:10px 0 0;color:#b3261e;font-size:13px;font-weight:700;line-height:1.3}' +
    '.AbcdSizeMsg[hidden]{display:none}' +
    '.AbcdSizeNeeded{animation:abcdSizeNeeded .45s ease 1}' +
    '.AbcdSizeNeeded .OlyxSizeBtn,.AbcdSizeNeeded .QuickAddDrawer__Option{border-color:#b3261e}' +
    '@keyframes abcdSizeNeeded{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}' +
    '@media (prefers-reduced-motion:reduce){.AbcdSizeNeeded{animation:none}}' +
    '.ProductForm:not(.AbcdSized) .shopify-payment-button{display:none!important}' +
    '#CartDrawerPro .cdp__rec-add:not([data-abcd-ok]){opacity:.55;pointer-events:none}' +
    '#CartDrawerPro .cdp__rec-add[data-abcd-ok]::before{content:""}';
  (document.head || document.documentElement).appendChild(st);

  function block(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function pdpList() { return document.querySelector('.ProductForm .OlyxInline--size .OlyxInline__SizeList'); }
  function pdpHasSizes() { return !!document.querySelector('.ProductForm .OlyxInline--size .OlyxSizeBtn'); }
  function qaOptions() { return document.querySelectorAll('.QuickAddDrawer__Option'); }

  function markSized() {
    document.querySelectorAll('.ProductForm').forEach(function (f) { f.classList.add('AbcdSized'); });
  }

  function message(host) {
    if (!host || !host.parentNode) return null;
    var m = host.parentNode.querySelector('.AbcdSizeMsg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'AbcdSizeMsg';
      m.setAttribute('role', 'alert');
      host.parentNode.insertBefore(m, host.nextSibling);
    }
    m.textContent = MSG;
    m.hidden = false;
    return m;
  }

  function hideMessages() {
    document.querySelectorAll('.AbcdSizeMsg').forEach(function (m) { m.hidden = true; });
  }

  function shake(el) {
    if (!el) return;
    if (!REDUCED) {
      el.classList.remove('AbcdSizeNeeded');
      void el.offsetWidth;
      el.classList.add('AbcdSizeNeeded');
    }
    try { el.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' }); } catch (e) {}
  }

  /* remove the "selected" look on the preselected product page size */
  function stripPdp() {
    if (pdpChosen) return;
    document.querySelectorAll('.ProductForm .OlyxInline--size .OlyxSizeBtn.is-selected').forEach(function (b) {
      b.classList.remove('is-selected');
    });
  }

  function keepSelectedLook(btn) {
    setTimeout(function () {
      var group = btn.closest('.OlyxInline--size');
      if (group && !group.querySelector('.OlyxSizeBtn.is-selected')) btn.classList.add('is-selected');
    }, 120);
  }

  /* a link with ?variant= is a choice, unless it points at the first variant (feeds link to that one) */
  function variantLinkIsChoice() {
    var m = /[?&]variant=(\d+)/.exec(location.search);
    if (!m) return false;
    try {
      var j = JSON.parse(document.querySelector('[data-product-json]').textContent);
      return String(j.product.variants[0].id) !== m[1];
    } catch (e) { return false; }
  }

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var qaOpen = t.closest('[data-quick-add-open]');
    if (qaOpen) { qaChosen = false; hideMessages(); return; }

    var pdpSize = t.closest('.ProductForm .OlyxInline--size .OlyxSizeBtn');
    if (pdpSize) {
      if (!pdpSize.disabled) { pdpChosen = true; markSized(); hideMessages(); keepSelectedLook(pdpSize); }
      return;
    }

    var qaSize = t.closest('.QuickAddDrawer__Option');
    if (qaSize) { qaChosen = true; hideMessages(); return; }

    var atc = t.closest('.ProductForm .ProductForm__AddToCart, .OlyxSticky__Btn');
    if (atc && !pdpChosen && pdpHasSizes()) {
      block(e);
      var list = pdpList();
      message(list);
      shake(list);
      return;
    }

    var qaSubmit = t.closest('[data-quick-add-submit], .QuickAddDrawer__AddButton');
    if (qaSubmit && !qaChosen && qaOptions().length > 1) {
      block(e);
      var opts = document.querySelector('[data-quick-add-options-list]') || qaOptions()[0].parentNode;
      message(opts);
      shake(opts);
      return;
    }

    /* cart drawer suggestions: never add before the size is resolved; "pick" sends to the product page */
    var rec = t.closest('#CartDrawerPro .cdp__rec-add');
    if (rec) {
      var ok = rec.getAttribute('data-abcd-ok');
      if (!ok) { block(e); return; }
      if (ok === 'pick') {
        block(e);
        var url = rec.getAttribute('data-abcd-url');
        if (url) location.href = url;
      }
    }
  }, true);

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form.ProductForm') && !pdpChosen && pdpHasSizes()) {
      block(e);
      var list = pdpList();
      message(list);
      shake(list);
    }
  }, true);

  /* ---------- cart drawer suggestions: same size or choose a size ---------- */
  var RT = {
    nl: { add: 'Voeg toe · __S__', plain: 'Toevoegen', pick: 'Kies maat' },
    fr: { add: 'Ajouter · __S__', plain: 'Ajouter', pick: 'Choisir la taille' },
    de: { add: 'Hinzufügen · __S__', plain: 'Hinzufügen', pick: 'Größe wählen' },
    it: { add: 'Aggiungi · __S__', plain: 'Aggiungi', pick: 'Scegli la taglia' },
    en: { add: 'Add · __S__', plain: 'Add', pick: 'Choose size' }
  };
  var RTX = RT[lang] || RT.nl;
  var prodCache = {};

  /* only real shoe sizes count as a size: "EU 40.5 / US M 7.5 ..." */
  function sizeKey(title) {
    var m = /EU\s*([\d.]+)/i.exec(String(title || ''));
    return m ? 'eu' + m[1] : '';
  }

  function cartSizeKey() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = (c && c.items) || [];
        for (var i = 0; i < items.length; i++) {
          var k = sizeKey(items[i].variant_title);
          if (k) return { key: k, label: k.slice(2) };
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function getProduct(handle) {
    if (!prodCache[handle]) {
      prodCache[handle] = fetch(ROOT + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return prodCache[handle];
  }

  var recBusy = false;
  function fixRecs() {
    var btns = document.querySelectorAll('#CartDrawerPro [data-cdp-recs] .cdp__rec-add:not([data-abcd-ok])');
    if (!btns.length || recBusy) return;
    recBusy = true;
    cartSizeKey().then(function (size) {
      var jobs = [];
      btns.forEach(function (btn) {
        var card = btn.closest('.cdp__rec');
        var a = card && card.querySelector('.cdp__rec-title');
        var href = a ? (a.getAttribute('href') || '') : '';
        var handle = (href.split('/products/')[1] || '').split('?')[0].split('#')[0];
        if (!handle) {
          btn.setAttribute('data-abcd-ok', 'pick');
          btn.setAttribute('data-abcd-url', href || (ROOT + 'collections/all'));
          btn.textContent = RTX.pick;
          return;
        }
        jobs.push(getProduct(handle).then(function (p) {
          var hit = null, plain = false;
          var vs = (p && p.variants) || [];
          if (vs.length === 1 && vs[0].available) { hit = vs[0]; plain = true; }
          else if (vs.length > 1 && size) {
            for (var i = 0; i < vs.length; i++) {
              if (vs[i].available && sizeKey(vs[i].option1 || vs[i].title) === size.key) { hit = vs[i]; break; }
            }
          }
          if (hit) {
            btn.setAttribute('data-cdp-rec-add', String(hit.id));
            btn.setAttribute('data-abcd-ok', 'size');
            btn.textContent = plain ? RTX.plain : RTX.add.replace('__S__', size.label);
          } else {
            btn.setAttribute('data-abcd-ok', 'pick');
            btn.setAttribute('data-abcd-url', href || (ROOT + 'products/' + handle));
            btn.textContent = RTX.pick;
          }
        }).catch(function () {
          btn.setAttribute('data-abcd-ok', 'pick');
          btn.setAttribute('data-abcd-url', href || (ROOT + 'products/' + handle));
          btn.textContent = RTX.pick;
        }));
      });
      return Promise.all(jobs);
    }).then(function () { recBusy = false; scheduleRecs(); }, function () { recBusy = false; });
  }

  var recTimer = null;
  function scheduleRecs() {
    if (recTimer) return;
    recTimer = setTimeout(function () { recTimer = null; try { fixRecs(); } catch (e) {} }, 60);
  }

  /* a changed cart can change the size: resolve the suggestions again */
  document.addEventListener('cdp:updated', function () {
    document.querySelectorAll('#CartDrawerPro .cdp__rec-add[data-abcd-ok]').forEach(function (b) { b.removeAttribute('data-abcd-ok'); });
    scheduleRecs();
  });

  var drawer = document.getElementById('CartDrawerPro');
  new MutationObserver(scheduleRecs).observe(drawer || document.documentElement, { childList: true, subtree: true });

  function run() { try { stripPdp(); } catch (e) {} }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; run(); }, 40);
  }

  function start() {
    if (variantLinkIsChoice()) pdpChosen = true;
    if (pdpChosen || !pdpHasSizes()) markSized();
    run();
    setTimeout(run, 600);
    setTimeout(run, 2000);
    scheduleRecs();
    var form = document.querySelector('.ProductForm');
    if (form) new MutationObserver(schedule).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
